import { render, staticRenderFns } from "./ServerUpdatePage.vue?vue&type=template&id=4bfc9934"
import script from "./ServerUpdatePage.vue?vue&type=script&lang=js"
export * from "./ServerUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports